import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, TwitterAuthProvider } from "firebase/auth";
import {collection, getDocs, getFirestore, query, where, getDoc, doc, addDoc, updateDoc, deleteDoc, serverTimestamp} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCZNw-VM1NuicoJiUcCWNZ6AUCCO2Uf9zE",
  authDomain: "carrotandstick-3f160.firebaseapp.com",
  projectId: "carrotandstick-3f160",
  storageBucket: "carrotandstick-3f160.firebasestorage.app",
  messagingSenderId: "365217118433",
  appId: "1:365217118433:web:7c17c6234d7b91448a5fa0"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyBB7p6aKaNUXaC6KDy2iCmB3BfWd5xjRpY",
//   authDomain: "carrottvsstick.firebaseapp.com",
//   projectId: "carrottvsstick",
//   storageBucket: "carrottvsstick.firebasestorage.app",
//   messagingSenderId: "924115215529",
//   appId: "1:924115215529:web:e2122099f86cfe2ae275b8"
// };


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize providers
export const googleProvider = new GoogleAuthProvider();
export const twitterProvider = new TwitterAuthProvider();

export default app;

export const checkUserExists = async (search, searchType) => {
  // For email-based search, we can use the UID directly if we have it
  if (searchType === 'email') {
    // We need to search by email in the user collection
    const docRef = collection(db, 'user')
    const q = query(docRef, where('email', "==", search));

    const docSnap = await getDocs(q)
    if (!docSnap.empty){
      return docSnap.docs[0].data()
    }
  } else if (searchType === 'twitter_screen_name') {
    // Search by Twitter screen name
    const docRef = collection(db, 'user')
    const q = query(docRef, where('twitter_screen_name', "==", search));

    const docSnap = await getDocs(q)
    if (!docSnap.empty){
      return docSnap.docs[0].data()
    }
  }

  return false
}

// New function to get user by UID
export const getUserByUID = async (uid) => {
  const userRef = doc(db, "user", uid);
  const snap = await getDoc(userRef);

  if (snap.exists()) {
    return snap.data();
  }

  return false;
}

export const getAllDocs = async () => {
  const docRef = collection(db, 'user')
  const docs = await getDocs(docRef);
  if (docs.empty) return []
  return docs.docs.map(snapshot =>  snapshot.data())
}

export const getConfig = async () => {
  const docRef = collection(db, 'addresses',)
  const docSnap = await getDocs(docRef)
  if (docSnap.empty) return null;
  const _snap = docSnap.docs[0]
  return { id: _snap.id, ..._snap.data().config };
}

// Transaction management functions
export const getUserTransactions = async (userId) => {
  const transactionsRef = collection(db, 'transactions');
  const q = query(transactionsRef, where('userId', '==', userId));
  const querySnapshot = await getDocs(q);

  if (querySnapshot.empty) return [];

  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
}

export const addTransaction = async (userId, transactionData) => {
  const transactionsRef = collection(db, 'transactions');
  const newTransaction = {
    userId,
    transactionHash: transactionData.transactionHash,
    xlink: transactionData.xlink,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  };

  const docRef = await addDoc(transactionsRef, newTransaction);
  return { id: docRef.id, ...newTransaction };
}

export const updateTransaction = async (transactionId, transactionData) => {
  const transactionRef = doc(db, 'transactions', transactionId);
  const updateData = {
    transactionHash: transactionData.transactionHash,
    xlink: transactionData.xlink,
    updatedAt: serverTimestamp()
  };

  await updateDoc(transactionRef, updateData);
  return { id: transactionId, ...updateData };
}

export const deleteTransaction = async (transactionId) => {
  const transactionRef = doc(db, 'transactions', transactionId);
  await deleteDoc(transactionRef);
  return transactionId;
}

